import { actionGenerator, IReduxAction } from '../../utils/actions';

export const CHANGE_AUTO_PROLONG = 'CHECKOUT_INFO :: CHANGE_AUTO_PROLONG';

export type TChangeAutoProlongAction = IReduxAction<typeof CHANGE_AUTO_PROLONG, boolean>;

export const changeAutoProlong = actionGenerator<typeof CHANGE_AUTO_PROLONG, boolean>(CHANGE_AUTO_PROLONG);
